import { useState, type FormEvent } from "react";
import { api } from "../api";
import { CardPage } from "../components/CardPage";
import { t } from "../i18n";

/**
 * The device-code page byj-share's sign-in sends a person to: approved, back to the terminal, and a way back here.
 * A Share machine's sign-in (`machine`) is said to be one: the device it becomes serves its files to the browser (RFC-063 D5).
 */
export function Device({ initialCode, machine = false }: { initialCode: string; machine?: boolean }) {
  const [code, setCode] = useState(initialCode);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.approveDevice(code.trim());
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <CardPage title={t("login:deviceTitle")} lead={t(machine ? "login:deviceMachineLead" : "login:deviceLead")} back={done ? { to: "/shares", label: t("common:backToShares") } : undefined}>
      {done ? (
        <p className="ok-text">{t("login:deviceApproved")}</p>
      ) : (
        <form onSubmit={submit} className="stack">
          <label>
            {t("login:userCodeLabel")}
            <input
              className="code-input"
              value={code}
              autoComplete="one-time-code"
              autoCapitalize="characters"
              spellCheck={false}
              onChange={(e) => setCode(e.target.value)}
            />
          </label>
          <button type="submit" className="primary" disabled={busy || !code.trim()}>
            {busy ? t("login:approving") : t("login:approve")}
          </button>
        </form>
      )}
      {error && <p className="error">{t("common:error", { m: error })}</p>}
    </CardPage>
  );
}
